module.exports = __webpack_public_path__ + "static/media/animal.eb31262b.png";